import { render, staticRenderFns } from "./customer-vehicle-active-quotes.vue?vue&type=template&id=c5b02bb4&scoped=true&"
import script from "./customer-vehicle-active-quotes.vue?vue&type=script&lang=js&"
export * from "./customer-vehicle-active-quotes.vue?vue&type=script&lang=js&"
import style0 from "./customer-vehicle-active-quotes.vue?vue&type=style&index=0&id=c5b02bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b02bb4",
  null
  
)

export default component.exports